var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSortDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon_sort-descending_svg__a",
    "data-name": "icon_sort descending",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.18l-3.57 3.57a.25.25 0 01-.36 0h0L6.25 8.18",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 20,
    height: 20,
    xlinkHref: "#icon_sort-descending_svg__a",
    "data-name": "Non Editable Symbol Art"
  })));
}
export default SvgIconSortDescending;